import { QueryClient } from 'react-query';

// Constants for 24-hour cache duration
const ONE_DAY_MS = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

/**
 * Shared QueryClient instance for consistent caching behavior across the application
 * Configuration:
 * - cacheTime: 24 hours - data remains in cache for 24 hours after becoming unused
 * - staleTime: 24 hours - data is considered fresh for 24 hours
 * - refetchOnWindowFocus: false - prevent automatic refetch when window regains focus
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: ONE_DAY_MS,
      staleTime: ONE_DAY_MS,
      refetchOnWindowFocus: false,
      retry: 2, // Retry failed requests up to 2 times
    },
  },
});
